/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjcCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjrGridFilter from "@grapecity/wijmo.react.grid.filter"

import React, { useEffect, useState } from "react"
import { Button, Col, Container, Row } from "react-bootstrap"
import EmptyTextHeader from "../../../../components/FlexGridWrapper/EmptyTextHeader"
import GridFooter from "../../../../components/FlexGridWrapper/GridFooter"
import LocalAlertComponent from "../../../../components/LocalAlertComponent"
import {
  ModalOuter,
  TModalTypes,
} from "../../../../components/Modal/ModalOuter"
import Spinner from "../../../../components/Spinner"
import CONSTANT from "../../../../constant"
import AgcKosokuryoTarihuService from "../../../../service/billing/agcKosokuryoTarihu/agcKosokuryoTarihuService"
import { TAgcKosokuryoTarihuGetListRes } from "../../../../service/billing/agcKosokuryoTarihu/TAgcKosokuryoTarihu"
import { TWijmoCellTemplateContext } from "../../../../type/wijmoComponents"

//#region [type]

// DefaultCombo
export type TItem = { name: string; value: any }

// #endregion

/**
 * AGL鹿島ガラス高速料検索モーダル
 * 2022/10/01 AGCロジ鹿島 ⇒ AGL鹿島ガラスに分社化したため、表面文字列のみ変更
 * @param {*} props
 * @return {*} reactNode
 */
const AGCKosokuryoSearchModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title?: string
    footer?: React.ReactNode
    setAGCKosokuryo: (value: TAgcKosokuryoTarihuGetListRes) => unknown
  }
> = (props) => {
  //#region [state]
  // Grid
  const [pageSize, setPageSize] = useState<number>(50)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()

  // Spinner用
  const [isSpinnerShow, setIsSpinnerShow] = useState(false)

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()
  //#endregion

  //#region [method]
  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページサイズ
   * @returns CollectionView
   */

  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjcCore.CollectionView(data, {
      pageSize,
    })

  const [gridData, setGridData] = useState<{
    data: wjcCore.CollectionView
  }>({
    data: createCollectionView([], pageSize),
  })
  const gridInitialized = (grid: wjcGrid.FlexGrid) => {
    grid.itemsSource = gridData.data
    setFlexGrid(grid)
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async () => {
    setIsSpinnerShow(true)
    setAlertSource(undefined)

    try {
      const res = await new AgcKosokuryoTarihuService().getList()
      const newData = createCollectionView([...res.data], pageSize)
      flexGrid!.itemsSource = newData
      setGridData({ data: newData })
      flexGrid!.refresh()
    } catch (error) {
      setAlertSource(error)
    } finally {
      setIsSpinnerShow(false)
    }
  }
  /**
   * 選択ハンドラ
   * @param item
   */
  const submitHandler = (item: TAgcKosokuryoTarihuGetListRes) => {
    props.setAGCKosokuryo(item)
    props.setIsShow(false)
  }
  //#endregion

  //#region [effect]
  useEffect(() => {
    if (flexGrid == null) return

    if (props.isShow) {
      search()
    }
  }, [props.isShow, flexGrid])

  //#endregion
  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title ?? "AGL鹿島ガラス　高速料検索"}
      setIsShow={props.setIsShow}
      size={"xl"}
      footer={props.footer}>
      <Spinner inModal searching={isSpinnerShow}></Spinner>
      <Container fluid>
        {/* アラート表示 */}
        <Row>
          <Col>
            <LocalAlertComponent alertSource={AlertSource} />
          </Col>
        </Row>
        <Row>
          <Col style={{ height: "35rem" }}>
            <wjrGrid.FlexGrid
              {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
              keyActionTab={wjcGrid.KeyAction.None}
              selectionMode={wjcGrid.SelectionMode.Cell}
              initialized={gridInitialized}
              style={{ height: "30rem" }}>
              <wjrGridFilter.FlexGridFilter />
              <wjrGrid.FlexGridColumn
                header="選択"
                align={"center"}
                binding="AGC高速料ID">
                <EmptyTextHeader></EmptyTextHeader>
                <wjrGrid.FlexGridCellTemplate
                  cellType={wjrGrid.CellTemplateType.Cell}
                  template={(
                    context: TWijmoCellTemplateContext<TAgcKosokuryoTarihuGetListRes>
                  ) => (
                    <Button onClick={() => submitHandler(context.item)}>
                      選択
                    </Button>
                  )}
                />
              </wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                binding="高速料記号"
                isRequired={false}
                width={100}
                header="高速料記号"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                binding="請求理由"
                isRequired={false}
                width={170}
                header="請求理由"></wjrGrid.FlexGridColumn>
              {/* 2023/02/01時点では不要となったため非表示 */}
              {/* 将来的に復活もあり得ることが示唆されているため、項目自体は残す */}
              <wjrGrid.FlexGridColumn
                binding="高速代請求区間"
                isRequired={false}
                visible={false}
                width={250}
                header="高速代請求区間"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                binding="高速料税抜"
                isRequired={false}
                width={100}
                format="n"
                header="高速料税抜"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                binding="高速料税込"
                isRequired={false}
                width={100}
                format="n"
                header="高速料税込"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                binding="備考"
                isRequired={false}
                width={240}
                header="備考"></wjrGrid.FlexGridColumn>
            </wjrGrid.FlexGrid>
            <GridFooter
              pageSize={pageSize}
              setPageSize={setPageSize}
              gridData={gridData}
              isEnableExport={false}
              flexGrid={flexGrid}></GridFooter>
          </Col>
        </Row>
      </Container>
    </ModalOuter>
  )
}
export default AGCKosokuryoSearchModal
